import type { ReactNode } from 'react';

export const symbol_sync_saved_locally: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m438-497-64-64q-3-3-15 2t-23 9q-11 4-14.5 3.5T332-561q-9 9-9 21t9 21l85 85q9 9 21 9t21-9l181-170q0-11-2-22.5t-10.05-19.63q-8.79-8.87-20.87-8.87-12.08 0-21.08 9L438-497ZM40-120v-60h850q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H40Zm100-120q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h680q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm0-60h680v-480H140v480Zm0 0v-480 480Z"
		/>
	</svg>
);
